<template>
  <div>
    <div class="flex flex-wrap -mx-2 text-xs items-stretch">
      <div class="flex-1 w-full lg:w-1/1 px-4">
        <h1 slot="header" class="w-full text-lg py-4">
          Social Media:
        </h1>
        <div class="flex flex-row justify-between">
            <h2 class="text-grey-dark text-sm font-medium leading-normal pb-4 ">
                Active accounts will be displayed and linked from your profile on the Meet The Teams page(s)
            </h2>
            <div class="flex justify-around  w-1/6">
                <div @click="openLink(value.userApproval.social_media.facebook)"><icon class="h-8 w-8" name="facebook_circle" :center=false :class="{'opacity-25': value.userApproval.social_media.facebook.length === 0, 'cursor-pointer': value.userApproval.social_media.facebook.length > 0 }"></icon></div>
                <div @click="openLink(value.userApproval.social_media.linkedin)"><icon class="h-8 w-8" name="linked_in_circle" :center=false :class="{'opacity-25': value.userApproval.social_media.linkedin.length === 0, 'cursor-pointer': value.userApproval.social_media.linkedin.length > 0 }"></icon></div>
                <div @click="openLink(value.userApproval.social_media.twitter)"><icon class="h-8 w-8" name="twitter_circle" :center=false :class="{'opacity-25': value.userApproval.social_media.twitter.length === 0, 'cursor-pointer': value.userApproval.social_media.twitter.length > 0 }"></icon></div>
                <div @click="openLink(value.userApproval.social_media.instagram)"><icon class="h-8 w-8" name="instagram_circle" :center=false :class="{'opacity-25': value.userApproval.social_media.instagram.length === 0, 'cursor-pointer': value.userApproval.social_media.instagram.length > 0 }"></icon></div>
                <div @click="openLink(value.userApproval.social_media.youtube)"><icon class="h-8 w-8" name="youtube_circle" :center=false :class="{'opacity-25': value.userApproval.social_media.youtube.length === 0, 'cursor-pointer': value.userApproval.social_media.youtube.length > 0 }"></icon></div>
                <div @click="openLink(value.userApproval.social_media.pinterest)"><icon class="h-8 w-8" name="pinterest_circle" :center=false :class="{'opacity-25': value.userApproval.social_media.pinterest.length === 0, 'cursor-pointer': value.userApproval.social_media.pinterest.length > 0 }"></icon></div>
                <div @click="openLink(value.userApproval.social_media.tiktok)"><icon class="h-8 w-8" name="tiktok" :center=false :class="{'opacity-25': value.userApproval.social_media.tiktok.length === 0, 'cursor-pointer': value.userApproval.social_media.tiktok.length > 0 }"></icon></div>
            </div>
        </div>

        <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" for="facebook">Facebook:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Add the URL from your profile page on Facebook. This will show, and provide a link to your Facebook from your profile information on the Meet The Team pages</span>
              </div>
            </i><br>
            <div class="flex">
              <div class="w-5/6 border h-10 flex items-center mt-2 mr-4">
                <input type="text" :disabled="value.userApproval.status === 0" id="facebook" v-model="value.userApproval.social_media.facebook" placeholder="https://www.facebook.com/your-page-name" @change="validateLinks($event)" class="w-full hover:border-grey focus:border-grey-dark p-2 mr-4 h-8 text-sm">
                <icon v-if="value.userApproval.social_media.facebook" name="tick" :center="false" class="h-8 w-8 text-green"></icon>
              </div>
              <div @click="openLink(value.userApproval.social_media.facebook)">
               <icon :center=false class="h-8 w-8 mt-3" name="link_new" :class="{'cursor-pointer hover:text-black': value.userApproval.social_media.facebook.length > 0 }"></icon>
              </div>
            </div>
          </div>

          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" for="linkedin">Linkedin:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Add the URL from your profile page on Linkedin. This will show, and provide a link to your Linkedin from your profile information on the Meet The Team pages</span>
              </div>
            </i> <br>
            <div class="flex">
              <div class="w-5/6 border h-10 flex items-center mt-2 mr-4">
                <input type="text" :disabled="value.userApproval.status === 0" id="linkedin" v-model="value.userApproval.social_media.linkedin" placeholder="https://www.linkedin.com/company/your-page-name" @change="validateLinks($event)" class="w-full hover:border-grey focus:border-grey-dark p-2 mr-4 h-8 text-sm">
                <icon v-if="value.userApproval.social_media.linkedin" name="tick" :center="false" class="h-8 w-8 text-green"></icon>
              </div>
              <div @click="openLink(value.userApproval.social_media.linkedin)">
                <icon :center=false class="h-8 w-8 mt-3" name="link_new" :class="{'cursor-pointer hover:text-black': value.userApproval.social_media.linkedin.length > 0 }"></icon>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" for="twitter">Twitter:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Add the URL from your profile page on Twitter. This will show, and provide a link to your Twitter from your profile information on the Meet The Team pages</span>
              </div>
            </i> <br>
            <div class="flex">
              <div class="w-5/6 border h-10 flex items-center mt-2 mr-4">
                <input type="text" :disabled="value.userApproval.status === 0" id="twitter" v-model="value.userApproval.social_media.twitter" @change="validateLinks($event)" placeholder="https://twitter.com/your-page-name" class="w-full hover:border-grey focus:border-grey-dark p-2 mr-4 h-8 text-sm">
                <icon v-if="value.userApproval.social_media.twitter" name="tick" :center="false" class="h-8 w-8 text-green"></icon>
              </div>
              <div @click="openLink(value.userApproval.social_media.twitter)">
                <icon :center=false class="h-8 w-8 mt-3" name="link_new" :class="{'cursor-pointer hover:text-black': value.userApproval.social_media.twitter.length > 0 }"></icon>
              </div>
            </div>
          </div>

          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" for="instagram">Instagram:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Add the URL from your profile page on Instagram. This will show, and provide a link to your Instagram from your profile information on the Meet The Team pages</span>
              </div>
            </i> <br>
            <div class="flex">
              <div class="w-5/6 border h-10 flex items-center mt-2 mr-4">
                <input id="instagram" v-model="value.userApproval.social_media.instagram" @change="validateLinks($event)" placeholder="https://www.instagram.com/your-page-name" class="w-full hover:border-grey focus:border-grey-dark p-2 mr-4 h-8 text-sm">
                <icon v-if="value.userApproval.social_media.instagram" name="tick" :center="false" class="h-8 w-8 text-green"></icon>
              </div>
              <div @click="openLink(value.userApproval.social_media.instagram)">
                <icon :center=false class="h-8 w-8 mt-3 " name="link_new" :class="{'cursor-pointer hover:text-black': value.userApproval.social_media.instagram.length > 0 }"></icon>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" for="youtube">Youtube:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Add the URL from your profile page on Youtube. This will show, and provide a link to your Youtube from your profile information on the Meet The Team pages</span>
              </div>
            </i> <br>
            <div class="flex">
              <div class="w-5/6 border h-10 flex items-center mt-2 mr-4">
                <input type="text" :disabled="value.userApproval.status === 0" id="youtube" v-model="value.userApproval.social_media.youtube" @change="validateLinks($event)" placeholder="https://www.youtube.com/your-page-name" class="w-full hover:border-grey focus:border-grey-dark p-2 mr-4 h-8 text-sm">
                <icon v-if="value.userApproval.social_media.youtube" name="tick" :center="false" class="h-8 w-8 text-green"></icon>
              </div>
              <div @click="openLink(value.userApproval.social_media.youtube)">
                <icon :center=false class="h-8 w-8 mt-3" name="link_new" :class="{'cursor-pointer hover:text-black': value.userApproval.social_media.youtube.length > 0 }"></icon>
              </div>
            </div>
          </div>

          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" for="pinterest">Pinterest:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Add the URL from your profile page on Pinterest. This will show, and provide a link to your Pinterest from your profile information on the Meet The Team pages</span>
              </div>
            </i> <br>
            <div class="flex">
              <div class="w-5/6 border h-10 flex items-center mt-2 mr-4">
                <input type="text" :disabled="value.userApproval.status === 0" id="pinterest" v-model="value.userApproval.social_media.pinterest" @change="validateLinks($event)" placeholder="https://www.pinterest.co.uk/your-page-name" class="w-full hover:border-grey focus:border-grey-dark p-2 mr-4 h-8 text-sm">
                <icon v-if="value.userApproval.social_media.pinterest" name="tick" :center="false" class="h-8 w-8 text-green"></icon>
              </div>
              <div @click="openLink(value.userApproval.social_media.pinterest)">
                <icon :center=false class="h-8 w-8 mt-3" name="link_new" :class="{'cursor-pointer hover:text-black': value.userApproval.social_media.pinterest.length > 0 }"></icon>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" for="tiktok">TikTok:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Add the URL from your profile page on TikTok. This will show, and provide a link to your TikTok from your profile information on the Meet The Team pages</span>
              </div>
            </i> <br>
            <div class="flex">
              <div class="w-5/6 border h-10 flex items-center mt-2 mr-4">
                <input type="text" :disabled="value.userApproval.status === 0" id="tiktok" v-model="value.userApproval.social_media.tiktok" @change="validateLinks($event)" placeholder="https://www.tiktok.com/your-page-name" class="w-full hover:border-grey focus:border-grey-dark p-2 mr-4 h-8 text-sm">
                <icon v-if="value.userApproval.social_media.tiktok" name="tick" :center="false" class="h-8 w-8 text-green"></icon>
              </div>
              <div @click="openLink(value.userApproval.social_media.tiktok)">
                <icon :center=false class="h-8 w-8 mt-3" name="link_new" :class="{'cursor-pointer hover:text-black': value.userApproval.social_media.tiktok.length > 0 }"></icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'socialMedia',
  props: ['value'],
  methods: {
    validateLinks (event) {
      console.log(event.target.value)
      axios.get(event.target.value)
        .then(response => {
          if (response.status === 200) {
            console.log('good page')
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    openLink (link) {
      console.log('clicked')
      if (link.length < 1) {
        return
      }
      if (!link.startsWith('http', 0)) {
        link = 'https://' + link
      }
      window.open(link, '_blank')
    }
  },
  watch: {
    value: {
      handler (val) {
        this.$emit('input', val)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.input-icons i {
  position: absolute;
}
</style>
